import React from 'react';
import { motion } from 'framer-motion';
import { CrosshairIcon } from 'lucide-react';
import { bullets } from '../data/copy';
export function Bullets() {
  return <section className="relative w-full border-y-2 border-bone/10 bg-water/25 py-12 sm:py-24" aria-labelledby="bullets-title" data-id="element-14" data-mp="48i43e2ruer7">
      <div className="mx-auto max-w-6xl px-4 sm:px-8" data-id="element-15" data-mp="e0xpymh6vnhd">
        <h2 id="bullets-title" className="max-w-3xl font-display text-2xl uppercase leading-[0.95] text-bone sm:text-5xl" data-id="element-16" data-mp="e2igm10dum9y">
          Seis razones por las que la picada
          <span className="block text-chartreuse" data-id="element-17" data-mp="3hj7p3sjj0629">deja de ser casualidad.</span>
        </h2>

        <ul className="mt-8 grid gap-x-10 gap-y-6 sm:mt-12 sm:gap-y-9 md:grid-cols-2" data-id="element-18" data-mp="3mik985j0iz15">
          {bullets.map((b, i) => <motion.li key={b.kicker} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-70px'
        }} transition={{
          duration: 0.5,
          delay: i % 2 * 0.1
        }} className="flex gap-3 sm:gap-4" data-id="element-19" data-mp="11qih3snhxr1q" data-mpi={i}>
              <CrosshairIcon className="mt-0.5 h-5 w-5 shrink-0 text-chartreuse sm:mt-1 sm:h-6 sm:w-6" aria-hidden="true" data-id="element-20" data-mp="20wj6cc2316ti" />
              <div data-id="element-21" data-mp="1qxk71k37inj6">
                <h3 className="font-cond text-lg uppercase tracking-wide text-bone sm:text-xl" data-id="element-22" data-mp="1qw8v2wzly9gz">
                  {b.kicker}
                </h3>
                <p className="mt-1.5 font-body text-[0.9rem] leading-relaxed text-bone/75 sm:mt-2 sm:text-base" data-id="element-23" data-mp="1m0bnbf2eubft">
                  {b.text}
                </p>
              </div>
            </motion.li>)}
        </ul>
      </div>
    </section>;
}